/**
 * instagram-feed.json (build / public) — script: npm run sync:instagram
 */

const FEED_URL = `${process.env.PUBLIC_URL || ''}/instagram-feed.json`;

export async function fetchInstagramFeedPayload() {
  try {
    const res = await fetch(FEED_URL, { cache: 'no-store' });
    if (!res.ok) return { items: [] };
    const data = await res.json();
    return {
      items: Array.isArray(data.items) ? data.items : [],
      fetchedAt: data.fetchedAt || null,
    };
  } catch {
    return { items: [] };
  }
}

function titleFromCaption(caption) {
  if (!caption || !caption.trim()) return 'KAIN · Koleksiyon';
  const line = caption.trim().split('\n')[0];
  return line.length > 90 ? `${line.slice(0, 87)}…` : line;
}

export function instagramItemToWatch(item) {
  return {
    id: `ig-${item.id}`,
    name: titleFromCaption(item.caption),
    description: '@kainwatches · Güncel paylaşım',
    longDescription: item.caption?.trim() || '',
    price: 'İletişim',
    images: [item.coverUrl],
    source: 'instagram',
    permalink: item.permalink,
    mediaType: item.mediaType,
  };
}

export async function fetchInstagramWatches() {
  const { items } = await fetchInstagramFeedPayload();
  return items.map(instagramItemToWatch);
}

export async function getInstagramWatchByRawId(rawId) {
  const { items } = await fetchInstagramFeedPayload();
  const item = items.find((i) => String(i.id) === String(rawId));
  if (!item) return null;
  const w = instagramItemToWatch(item);
  if (!w.specs) {
    w.specs = [
      { name: 'Kaynak', value: 'Instagram @kainwatches' },
      { name: 'Medya', value: w.mediaType || '—' },
    ];
  }
  return w;
}
